<template>
  <v-dialog
    :value="showForm"
    persistent
    max-width="400px"
  >
    <v-alert
      :value="true"
      color="black"
      outline
      style="background: white;"
      class="text-md-left px-3 black--text">
      <div>
        <div class="body text-md-left">検査完了</div>
        <v-divider
          class="mt-2 mb-5"
        />
        <v-flex
          class="my-3">
          <div
            class="body">
            <div class="mb-3">
              内容を保存し、出品者がマイページにて最低落札希望価格の設定ができるようになります。<br>
              （セルフ検査の場合、出品票の再送信処理を行った場合は、本部に連絡してください）
            </div>
            <v-layout justify-end>
              <v-btn
                :loading="sending"
                class="mt-3"
                dark
                color="primary lighten-1"
                @click.native="sendRequest"
              >
                検査完了
              </v-btn>
              <v-btn
                class="mt-3"
                dark
                outline
                color="red lighten-1"
                @click.native="close"
              >
                キャンセル
              </v-btn>
            </v-layout>
          </div>
        </v-flex>
      </div>
    </v-alert>
  </v-dialog>
</template>

<script>
const APPOINTMENT_SUBSTATUS_INSPECTION_FINISHED = '202';
export default {
  data() {
    return {
      requestSent: false,
      sending: false,
      errorMessage: null,
    };
  },
  computed: {
    showForm() {
      return this.$store.state.showFinishedDialog;
    },
  },
  methods: {
    sendRequest() {
      this.sending = true;

      this.updateAppointment({ field: 'substatus', value: APPOINTMENT_SUBSTATUS_INSPECTION_FINISHED })
        .then(resp => this.success(resp));
    },
    success() {
      this.requestSent = true;
      this.sending = false;

      this.$store.commit('toggleFinishedDialog');

      this.$router.push('/search/');
    },
    error({ status }) {
      this.requestSent = false;
      this.sending = false;

      this.errorMessage = status.error_message;
    },
    close() {
      this.$store.commit('toggleFinishedDialog');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FinishedDialog.vue